import { render } from "./ActividadesPage.vue?vue&type=template&id=dbfa67fe"
import script from "./ActividadesPage.vue?vue&type=script&lang=js"
export * from "./ActividadesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__